import React from 'react';
import Image from 'next/image';
import classNames from 'classnames';

function Reviews({ isCelebritieLandingPage }) {
  return (
    <section className="section-reviews wf-section">
      <div className="block__subtitle">
        <div className="content__medium">
          <h2
            className={classNames('h2__36', {
              'white-text': isCelebritieLandingPage,
            })}>
            Over 30,000 5-star reviews
          </h2>
        </div>
      </div>
      <div className="scroll__reviews">
        <div className="block__reviews">
          <div
            data-w-id="e045af7b-b969-6cbb-591f-c6f965587943"
            className={classNames('item__review', {
              'review-card-celeb': isCelebritieLandingPage,
            })}>
            <div className="block__icons-stars">
              <div className="icon__24 yellow w-embed">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24">
                  <path
                    fill="currentColor"
                    d="M11.4882 3.2787c.1834-.3716.7134-.3716.8968 0l2.3742 4.8107a.4997.4997 0 00.3765.2735l5.3089.7714c.4101.0596.5738.5636.2771.8529l-3.8416 3.7446a.5003.5003 0 00-.1438.4426l.9069 5.2874c.07.4085-.3587.72-.7255.5271l-4.7484-2.4964a.5.5 0 00-.4654 0l-4.7484 2.4964c-.3668.1929-.7955-.1186-.7255-.5271l.907-5.2874a.5003.5003 0 00-.1439-.4426L3.1515 9.9872c-.2967-.2893-.133-.7933.2771-.8529l5.309-.7714a.4997.4997 0 00.3764-.2735l2.3742-4.8107z"></path>
                </svg>
              </div>
              <div className="icon__24 yellow w-embed">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24">
                  <path
                    fill="currentColor"
                    d="M11.4882 3.2787c.1834-.3716.7134-.3716.8968 0l2.3742 4.8107a.4997.4997 0 00.3765.2735l5.3089.7714c.4101.0596.5738.5636.2771.8529l-3.8416 3.7446a.5003.5003 0 00-.1438.4426l.9069 5.2874c.07.4085-.3587.72-.7255.5271l-4.7484-2.4964a.5.5 0 00-.4654 0l-4.7484 2.4964c-.3668.1929-.7955-.1186-.7255-.5271l.907-5.2874a.5003.5003 0 00-.1439-.4426L3.1515 9.9872c-.2967-.2893-.133-.7933.2771-.8529l5.309-.7714a.4997.4997 0 00.3764-.2735l2.3742-4.8107z"></path>
                </svg>
              </div>
              <div className="icon__24 yellow w-embed">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24">
                  <path
                    fill="currentColor"
                    d="M11.4882 3.2787c.1834-.3716.7134-.3716.8968 0l2.3742 4.8107a.4997.4997 0 00.3765.2735l5.3089.7714c.4101.0596.5738.5636.2771.8529l-3.8416 3.7446a.5003.5003 0 00-.1438.4426l.9069 5.2874c.07.4085-.3587.72-.7255.5271l-4.7484-2.4964a.5.5 0 00-.4654 0l-4.7484 2.4964c-.3668.1929-.7955-.1186-.7255-.5271l.907-5.2874a.5003.5003 0 00-.1439-.4426L3.1515 9.9872c-.2967-.2893-.133-.7933.2771-.8529l5.309-.7714a.4997.4997 0 00.3764-.2735l2.3742-4.8107z"></path>
                </svg>
              </div>
              <div className="icon__24 yellow w-embed">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24">
                  <path
                    fill="currentColor"
                    d="M11.4882 3.2787c.1834-.3716.7134-.3716.8968 0l2.3742 4.8107a.4997.4997 0 00.3765.2735l5.3089.7714c.4101.0596.5738.5636.2771.8529l-3.8416 3.7446a.5003.5003 0 00-.1438.4426l.9069 5.2874c.07.4085-.3587.72-.7255.5271l-4.7484-2.4964a.5.5 0 00-.4654 0l-4.7484 2.4964c-.3668.1929-.7955-.1186-.7255-.5271l.907-5.2874a.5003.5003 0 00-.1439-.4426L3.1515 9.9872c-.2967-.2893-.133-.7933.2771-.8529l5.309-.7714a.4997.4997 0 00.3764-.2735l2.3742-4.8107z"></path>
                </svg>
              </div>
              <div className="icon__24 yellow w-embed">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24">
                  <path
                    fill="currentColor"
                    d="M11.4882 3.2787c.1834-.3716.7134-.3716.8968 0l2.3742 4.8107a.4997.4997 0 00.3765.2735l5.3089.7714c.4101.0596.5738.5636.2771.8529l-3.8416 3.7446a.5003.5003 0 00-.1438.4426l.9069 5.2874c.07.4085-.3587.72-.7255.5271l-4.7484-2.4964a.5.5 0 00-.4654 0l-4.7484 2.4964c-.3668.1929-.7955-.1186-.7255-.5271l.907-5.2874a.5003.5003 0 00-.1439-.4426L3.1515 9.9872c-.2967-.2893-.133-.7933.2771-.8529l5.309-.7714a.4997.4997 0 00.3764-.2735l2.3742-4.8107z"></path>
                </svg>
              </div>
            </div>
            <div className="block__text-review">
              <p className="p__review">
                I am not over exaggerating when I say this app changed my life
                and I hope to never lose it. It helped me become my most
                beautiful, true self and showed my true path in life.
              </p>
            </div>
            <div
              id="w-node-f9f1c2b4-4d7b-06b7-3792-498e31eeabdb-4a13af8c"
              className="block_author-review">
              <Image
                src="/static/newLandingPageContent/images/5fddc1c3e66c08310b61bdd1_Ellipse-14.png"
                // loading="lazy"
                id="w-node-_12bf6a94-bcfb-6b43-0d4b-ac32384ba6ff-4a13af8c"
                alt=""
                className="avatar-author"
                height={36}
                width={36}
              />
              <div className="block-author">
                <p className="p__review-name">Brittany M</p>
                <p
                  className={classNames('p__review-aura', {
                    'review-text': isCelebritieLandingPage,
                  })}>
                  Aura member
                </p>
              </div>
            </div>
          </div>
          <div
            data-w-id="66b82b88-ae27-e6bd-ff44-27de5eebbb53"
            className={classNames('item__review', {
              'review-card-celeb': isCelebritieLandingPage,
            })}>
            <div className="block__icons-stars">
              <div className="icon__24 yellow w-embed">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24">
                  <path
                    fill="currentColor"
                    d="M11.4882 3.2787c.1834-.3716.7134-.3716.8968 0l2.3742 4.8107a.4997.4997 0 00.3765.2735l5.3089.7714c.4101.0596.5738.5636.2771.8529l-3.8416 3.7446a.5003.5003 0 00-.1438.4426l.9069 5.2874c.07.4085-.3587.72-.7255.5271l-4.7484-2.4964a.5.5 0 00-.4654 0l-4.7484 2.4964c-.3668.1929-.7955-.1186-.7255-.5271l.907-5.2874a.5003.5003 0 00-.1439-.4426L3.1515 9.9872c-.2967-.2893-.133-.7933.2771-.8529l5.309-.7714a.4997.4997 0 00.3764-.2735l2.3742-4.8107z"></path>
                </svg>
              </div>
              <div className="icon__24 yellow w-embed">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24">
                  <path
                    fill="currentColor"
                    d="M11.4882 3.2787c.1834-.3716.7134-.3716.8968 0l2.3742 4.8107a.4997.4997 0 00.3765.2735l5.3089.7714c.4101.0596.5738.5636.2771.8529l-3.8416 3.7446a.5003.5003 0 00-.1438.4426l.9069 5.2874c.07.4085-.3587.72-.7255.5271l-4.7484-2.4964a.5.5 0 00-.4654 0l-4.7484 2.4964c-.3668.1929-.7955-.1186-.7255-.5271l.907-5.2874a.5003.5003 0 00-.1439-.4426L3.1515 9.9872c-.2967-.2893-.133-.7933.2771-.8529l5.309-.7714a.4997.4997 0 00.3764-.2735l2.3742-4.8107z"></path>
                </svg>
              </div>
              <div className="icon__24 yellow w-embed">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24">
                  <path
                    fill="currentColor"
                    d="M11.4882 3.2787c.1834-.3716.7134-.3716.8968 0l2.3742 4.8107a.4997.4997 0 00.3765.2735l5.3089.7714c.4101.0596.5738.5636.2771.8529l-3.8416 3.7446a.5003.5003 0 00-.1438.4426l.9069 5.2874c.07.4085-.3587.72-.7255.5271l-4.7484-2.4964a.5.5 0 00-.4654 0l-4.7484 2.4964c-.3668.1929-.7955-.1186-.7255-.5271l.907-5.2874a.5003.5003 0 00-.1439-.4426L3.1515 9.9872c-.2967-.2893-.133-.7933.2771-.8529l5.309-.7714a.4997.4997 0 00.3764-.2735l2.3742-4.8107z"></path>
                </svg>
              </div>
              <div className="icon__24 yellow w-embed">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24">
                  <path
                    fill="currentColor"
                    d="M11.4882 3.2787c.1834-.3716.7134-.3716.8968 0l2.3742 4.8107a.4997.4997 0 00.3765.2735l5.3089.7714c.4101.0596.5738.5636.2771.8529l-3.8416 3.7446a.5003.5003 0 00-.1438.4426l.9069 5.2874c.07.4085-.3587.72-.7255.5271l-4.7484-2.4964a.5.5 0 00-.4654 0l-4.7484 2.4964c-.3668.1929-.7955-.1186-.7255-.5271l.907-5.2874a.5003.5003 0 00-.1439-.4426L3.1515 9.9872c-.2967-.2893-.133-.7933.2771-.8529l5.309-.7714a.4997.4997 0 00.3764-.2735l2.3742-4.8107z"></path>
                </svg>
              </div>
              <div className="icon__24 yellow w-embed">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24">
                  <path
                    fill="currentColor"
                    d="M11.4882 3.2787c.1834-.3716.7134-.3716.8968 0l2.3742 4.8107a.4997.4997 0 00.3765.2735l5.3089.7714c.4101.0596.5738.5636.2771.8529l-3.8416 3.7446a.5003.5003 0 00-.1438.4426l.9069 5.2874c.07.4085-.3587.72-.7255.5271l-4.7484-2.4964a.5.5 0 00-.4654 0l-4.7484 2.4964c-.3668.1929-.7955-.1186-.7255-.5271l.907-5.2874a.5003.5003 0 00-.1439-.4426L3.1515 9.9872c-.2967-.2893-.133-.7933.2771-.8529l5.309-.7714a.4997.4997 0 00.3764-.2735l2.3742-4.8107z"></path>
                </svg>
              </div>
            </div>
            <div className="block__text-review">
              <p className="p__review">
                Aura is by far the best meditation application i ever used.
                Every single time I get to fall asleep peacefully and wake up
                rested. Aura’s personalization is magical and knows just what
                works for me. Thank you!
              </p>
            </div>
            <div
              id="w-node-_66b82b88-ae27-e6bd-ff44-27de5eebbb59-4a13af8c"
              className="block_author-review">
              <Image
                src="/static/newLandingPageContent/images/5fddc2d7db191128a7ba70bf_Ellipse-141.png"
                // loading="lazy"
                alt=""
                className="avatar-author"
                height={36}
                width={36}
              />
              <div className="block-author">
                <p className="p__review-name">Katherine A</p>
                <p
                  className={classNames('p__review-aura', {
                    'review-text': isCelebritieLandingPage,
                  })}>
                  Aura member
                </p>
              </div>
            </div>
          </div>
          <div
            data-w-id="ed5689d8-dd23-4b25-68ab-616124632127"
            className={classNames('item__review', {
              'review-card-celeb': isCelebritieLandingPage,
            })}>
            <div className="block__icons-stars">
              <div className="icon__24 yellow w-embed">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24">
                  <path
                    fill="currentColor"
                    d="M11.4882 3.2787c.1834-.3716.7134-.3716.8968 0l2.3742 4.8107a.4997.4997 0 00.3765.2735l5.3089.7714c.4101.0596.5738.5636.2771.8529l-3.8416 3.7446a.5003.5003 0 00-.1438.4426l.9069 5.2874c.07.4085-.3587.72-.7255.5271l-4.7484-2.4964a.5.5 0 00-.4654 0l-4.7484 2.4964c-.3668.1929-.7955-.1186-.7255-.5271l.907-5.2874a.5003.5003 0 00-.1439-.4426L3.1515 9.9872c-.2967-.2893-.133-.7933.2771-.8529l5.309-.7714a.4997.4997 0 00.3764-.2735l2.3742-4.8107z"></path>
                </svg>
              </div>
              <div className="icon__24 yellow w-embed">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24">
                  <path
                    fill="currentColor"
                    d="M11.4882 3.2787c.1834-.3716.7134-.3716.8968 0l2.3742 4.8107a.4997.4997 0 00.3765.2735l5.3089.7714c.4101.0596.5738.5636.2771.8529l-3.8416 3.7446a.5003.5003 0 00-.1438.4426l.9069 5.2874c.07.4085-.3587.72-.7255.5271l-4.7484-2.4964a.5.5 0 00-.4654 0l-4.7484 2.4964c-.3668.1929-.7955-.1186-.7255-.5271l.907-5.2874a.5003.5003 0 00-.1439-.4426L3.1515 9.9872c-.2967-.2893-.133-.7933.2771-.8529l5.309-.7714a.4997.4997 0 00.3764-.2735l2.3742-4.8107z"></path>
                </svg>
              </div>
              <div className="icon__24 yellow w-embed">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24">
                  <path
                    fill="currentColor"
                    d="M11.4882 3.2787c.1834-.3716.7134-.3716.8968 0l2.3742 4.8107a.4997.4997 0 00.3765.2735l5.3089.7714c.4101.0596.5738.5636.2771.8529l-3.8416 3.7446a.5003.5003 0 00-.1438.4426l.9069 5.2874c.07.4085-.3587.72-.7255.5271l-4.7484-2.4964a.5.5 0 00-.4654 0l-4.7484 2.4964c-.3668.1929-.7955-.1186-.7255-.5271l.907-5.2874a.5003.5003 0 00-.1439-.4426L3.1515 9.9872c-.2967-.2893-.133-.7933.2771-.8529l5.309-.7714a.4997.4997 0 00.3764-.2735l2.3742-4.8107z"></path>
                </svg>
              </div>
              <div className="icon__24 yellow w-embed">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24">
                  <path
                    fill="currentColor"
                    d="M11.4882 3.2787c.1834-.3716.7134-.3716.8968 0l2.3742 4.8107a.4997.4997 0 00.3765.2735l5.3089.7714c.4101.0596.5738.5636.2771.8529l-3.8416 3.7446a.5003.5003 0 00-.1438.4426l.9069 5.2874c.07.4085-.3587.72-.7255.5271l-4.7484-2.4964a.5.5 0 00-.4654 0l-4.7484 2.4964c-.3668.1929-.7955-.1186-.7255-.5271l.907-5.2874a.5003.5003 0 00-.1439-.4426L3.1515 9.9872c-.2967-.2893-.133-.7933.2771-.8529l5.309-.7714a.4997.4997 0 00.3764-.2735l2.3742-4.8107z"></path>
                </svg>
              </div>
              <div className="icon__24 yellow w-embed">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24">
                  <path
                    fill="currentColor"
                    d="M11.4882 3.2787c.1834-.3716.7134-.3716.8968 0l2.3742 4.8107a.4997.4997 0 00.3765.2735l5.3089.7714c.4101.0596.5738.5636.2771.8529l-3.8416 3.7446a.5003.5003 0 00-.1438.4426l.9069 5.2874c.07.4085-.3587.72-.7255.5271l-4.7484-2.4964a.5.5 0 00-.4654 0l-4.7484 2.4964c-.3668.1929-.7955-.1186-.7255-.5271l.907-5.2874a.5003.5003 0 00-.1439-.4426L3.1515 9.9872c-.2967-.2893-.133-.7933.2771-.8529l5.309-.7714a.4997.4997 0 00.3764-.2735l2.3742-4.8107z"></path>
                </svg>
              </div>
            </div>
            <div className="block__text-review">
              <p className="p__review">
                Hello, so your app has literally changed my life. I feel light
                and happy, only within about 12 days. My family, and friends
                actually want to talk to me again. They instantly noticed I was
                me again but better. I have already suggested your app to so
                many others now and I will continue to do so, because it has
                literally saved my life.
              </p>
            </div>
            <div
              id="w-node-ed5689d8-dd23-4b25-68ab-61612463212d-4a13af8c"
              className="block_author-review">
              <Image
                src="/static/newLandingPageContent/images/5fddc2e1e074c00614f84aee_Ellipse-142.png"
                alt=""
                className="avatar-author"
                height={36}
                width={36}
              />
              <div className="block-author">
                <p className="p__review-name">Andrea S</p>
                <p
                  className={classNames('p__review-aura', {
                    'review-text': isCelebritieLandingPage,
                  })}>
                  Aura member
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Reviews;
